<bn-loading-overlay></bn-loading-overlay>
<div class="d-flex justify-content-end">
    <button [disabled]="limites?.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarLista()"
    placement="top" ngbTooltip="Exporta todos os limites listados">
    <i class="fa fa-file"></i> Exportar limites</button>
</div>
<div *ngIf="dataLimites && limites?.length" class="container letra-miuda">
    Consulta realizada em: {{ dataLimites }}
</div>
<div class="alert alert-info" *ngIf="!exibeListagem() && limites?.length > 0">Não foram encontrados limites para o Agente Financeiro selecionado</div>
<div class="table-responsive" *ngIf="exibeListagem()">
    <table class="table table-hover">
        <thead>
        <tr>
            <th >Agente Financeiro</th>
            <th class="text-end" container="body" ngbTooltip="Valor subscrito líquido (aporte – resgate)">Valor subscrito</th>
            <th class="titulo-moeda">Limite garantia</th>
            <th class="titulo-moeda">Comprometido atual</th>
            <th class="titulo-moeda">Comprometido legado</th>
            <th class="titulo-moeda">Valor disponível</th>
        <tr>
        </thead>
        <tbody>
        <tr *ngFor="let limite of limites" [ngClass]="getDestaqueLimite(limite)">

            <td>
                {{limite.razaoSocial}}
            </td>
            <td [ngClass]="'moeda'">
                {{ limite?.valorSubscrito | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda'">
                {{ limite?.valorLimiteGarantia | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda'">
                {{ limite?.comprometido | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda'">
                {{ limite?.comprometidoLegado | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda'">
                {{ limite?.valorDisponivel | bnMask:'MOEDA' }}
            </td>
        </tr>
        </tbody>
    </table>
</div>
